
import { replaceBus } from '@/components/ReplaceDialog.vue';
import { Conflict } from '@/store/modules/Upload';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import PhotosModule from '@/store/modules/Photos';
import store from '@/store';

const photosModule = getModule(PhotosModule, store);

@Component({})
export default class ConflictHover extends Vue {
    @Prop({
        required: true,
        type: Boolean,
    })
    overlayVisible!: boolean;

    @Prop({
        required: true,
        type: String,
    })
    photoId!: string;

    @Prop({
        required: true,
        type: Boolean,
    })
    isUploaded!: boolean;

    @Prop({
        required: true,
        type: Object,
    })
    conflict!: Conflict;

    resolveConflict() {
        replaceBus.$emit('resolveConflictOverride', <Conflict>{
            ...this.conflict,
            conflicted: photosModule.remotePhotos[this.photoId],
        });
    }
}

